<template>
    <el-popconfirm
        :confirm-button-text="confirmButtonText"
        :cancel-button-text="cancelButtonText"
        :icon-color="buttonText == '删除' ? '#f00' : '#f90'"
        :title="`确定${title}？`"
        @onConfirm="confirm"
        @onCancel="cancel"
    >
        <el-button
            slot="reference"
            type="text"
            size="small"
            :class="buttonText == '删除' ? 'redText' : ''"
            >{{ buttonText }}</el-button
        >
    </el-popconfirm>
</template>

<script>
export default {
    name: "del-pop-confirm",
    props: {
        title: {
            type: String,
            default: "",
        },
        buttonText: {
            type: String,
            default: "111",
        },
        confirmButtonText: {
            type: String,
            default: "确认",
        },
        cancelButtonText: {
            type: String,
            default: "取消",
        },
    },
    methods: {
        del() {
            this.$emit("del");
        },
        confirm() {
            this.$emit("confirm");
        },
        cancel() {
          this.$emit("cancel");
        },
    },
};
</script>

<style></style>
